import type { AffiliateLinkStatsParams } from '@metapic-apps/shared'
import type { Ref } from 'vue'

import { useApi } from '@/lib/helpers/api.helpers'
import { financeClient } from '@/lib/services/finance.service'

type DateRange = { startDate: string; endDate: string }

export const useAffiliateLinkStats = (
  linkIdRef: Ref<number | null>,
  dateRangeRef: Ref<DateRange | undefined>,
) => {
  const { data, isLoading, error } = useApi(async () => {
    const linkId = linkIdRef.value
    if (linkId == null) {
      return undefined
    }

    const dateRange = dateRangeRef.value
    const params: AffiliateLinkStatsParams = {
      ...(dateRange?.startDate && { start_date: dateRange.startDate }),
      ...(dateRange?.endDate && { end_date: dateRange.endDate }),
    }

    return financeClient.affiliateLinkStatsControllerGetLinkStats(linkId, params)
  })

  return { data, isLoading, error }
}
